import type { ReactNode } from 'react';

import { cn } from '@/lib/cn';

/** A label/value list — vervangt `.detail-list` / `.profile-summary`. */
export function DescriptionList({
  items,
  className,
}: {
  items: { label: ReactNode; value: ReactNode }[];
  className?: string;
}) {
  return (
    <dl className={cn('grid grid-cols-[max-content_1fr] gap-x-5 gap-y-1.5', className)}>
      {items.map((item, index) => (
        <div className="contents" key={index}>
          <dt className="text-accent text-[13px]">{item.label}</dt>
          <dd className="text-ink m-0 text-sm">{item.value}</dd>
        </div>
      ))}
    </dl>
  );
}
